import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  FilledInput,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  Paper,
  Typography,
} from "@mui/material";
import React, { useCallback, useContext, useState } from "react";
import { LoadingButton } from "@mui/lab";
import axios from "axios";
import { TokenTeacher } from "../TeacherApp/TeacherApp.component";

const LogInTeacher = () => {
    const { updateToken } = useContext(TokenTeacher);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [password, setPassword] = useState<string>("");

  const handleClickShowPassword = useCallback(
    () => setShowPassword((show) => !show),
    []
  );

  const handleMouseDownPassword = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
    },
    []
  );

  const handleMouseUpPassword = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
    },
    []
  );

  const handleOnSubmit = useCallback(async () => {
    if (password.length > 0) {
      try {
        setIsSubmitting(true);
        const response = await axios.post(
          "https://loginteacher-5kg2vejuqa-uc.a.run.app",
          {
            password: password,
          }
        );
        const data = response.data;
        if (typeof data === "object" && typeof data.token === "string") {
          updateToken(data.token);
        } else {
          throw new Error("Error al consumir el servicio");
        }
      } catch {
        alert("Contraseña incorrecta.");
      } finally {
        setIsSubmitting(false);
      }
    }
  }, [updateToken, password]);

  return (
    <div className="h-screen w-screen flex p-5">
      <Paper className="m-auto p-5 tablet:p-10 space-y-4 flex flex-col items-center max-w-[500px]">
        <div className="py-5">
          <img
            src="logo.png"
            className="self-center max-w-[100px]"
            alt="logo"
          />
        </div>
        <Typography variant="body1" className="text-center">
          Bienvenido,
          <br />
          Para continuar, por favor ingresa tu contraseña
        </Typography>
        <FormControl variant="filled" className="w-full">
          <InputLabel htmlFor="filled-adornment-password">
            Contraseña
          </InputLabel>
          <FilledInput
            id="filled-adornment-password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label={
                    showPassword ? "hide the password" : "display the password"
                  }
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  onMouseUp={handleMouseUpPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        <div className="py-5 w-full">
          <LoadingButton
            onClick={handleOnSubmit}
            loading={isSubmitting}
            className="bg-[#06B1D3] w-full"
            variant="contained"
          >
            Ingresar
          </LoadingButton>
        </div>
      </Paper>
    </div>
  );
};

export { LogInTeacher };
